/**
 * @fileoverview gRPC-Web generated client stub for users
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v7.36.2
// source: user.proto


/* eslint-disable no-unused-vars */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.users = require('./user_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.users.UsernatorClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.users.UsernatorPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.LoginRequest,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_Login = new grpc.web.MethodDescriptor(
  '/users.Usernator/Login',
  grpc.web.MethodType.UNARY,
  proto.users.LoginRequest,
  proto.users.UserData,
  /**
   * @param {!proto.users.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.login =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/Login',
      request,
      metadata || {},
      methodDescriptor_Usernator_Login,
      callback);
};


/**
 * @param {!proto.users.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.login =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/Login',
      request,
      metadata || {},
      methodDescriptor_Usernator_Login);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.LoginRequest,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_Register = new grpc.web.MethodDescriptor(
  '/users.Usernator/Register',
  grpc.web.MethodType.UNARY,
  proto.users.LoginRequest,
  proto.users.UserData,
  /**
   * @param {!proto.users.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.register =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/Register',
      request,
      metadata || {},
      methodDescriptor_Usernator_Register,
      callback);
};


/**
 * @param {!proto.users.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.register =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/Register',
      request,
      metadata || {},
      methodDescriptor_Usernator_Register);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UdpatePassword,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_updatePassword = new grpc.web.MethodDescriptor(
  '/users.Usernator/updatePassword',
  grpc.web.MethodType.UNARY,
  proto.users.UdpatePassword,
  proto.users.UserData,
  /**
   * @param {!proto.users.UdpatePassword} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.UdpatePassword} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.updatePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/updatePassword',
      request,
      metadata || {},
      methodDescriptor_Usernator_updatePassword,
      callback);
};


/**
 * @param {!proto.users.UdpatePassword} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.updatePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/updatePassword',
      request,
      metadata || {},
      methodDescriptor_Usernator_updatePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.AddFriendRequest,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_addFriend = new grpc.web.MethodDescriptor(
  '/users.Usernator/addFriend',
  grpc.web.MethodType.UNARY,
  proto.users.AddFriendRequest,
  proto.users.UserData,
  /**
   * @param {!proto.users.AddFriendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.AddFriendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.addFriend =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/addFriend',
      request,
      metadata || {},
      methodDescriptor_Usernator_addFriend,
      callback);
};


/**
 * @param {!proto.users.AddFriendRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.addFriend =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/addFriend',
      request,
      metadata || {},
      methodDescriptor_Usernator_addFriend);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.AddFriendRequest,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_removeFriend = new grpc.web.MethodDescriptor(
  '/users.Usernator/removeFriend',
  grpc.web.MethodType.UNARY,
  proto.users.AddFriendRequest,
  proto.users.UserData,
  /**
   * @param {!proto.users.AddFriendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.AddFriendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.removeFriend =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/removeFriend',
      request,
      metadata || {},
      methodDescriptor_Usernator_removeFriend,
      callback);
};


/**
 * @param {!proto.users.AddFriendRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.removeFriend =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/removeFriend',
      request,
      metadata || {},
      methodDescriptor_Usernator_removeFriend);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.UserDatas>}
 */
const methodDescriptor_Usernator_getFriends = new grpc.web.MethodDescriptor(
  '/users.Usernator/getFriends',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.UserDatas,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserDatas.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserDatas)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserDatas>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.getFriends =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/getFriends',
      request,
      metadata || {},
      methodDescriptor_Usernator_getFriends,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserDatas>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.getFriends =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/getFriends',
      request,
      metadata || {},
      methodDescriptor_Usernator_getFriends);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_validateSession = new grpc.web.MethodDescriptor(
  '/users.Usernator/validateSession',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.UserData,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.validateSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/validateSession',
      request,
      metadata || {},
      methodDescriptor_Usernator_validateSession,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.validateSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/validateSession',
      request,
      metadata || {},
      methodDescriptor_Usernator_validateSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.UserDatas>}
 */
const methodDescriptor_Usernator_getAllUsers = new grpc.web.MethodDescriptor(
  '/users.Usernator/getAllUsers',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.UserDatas,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserDatas.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserDatas)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserDatas>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.getAllUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/getAllUsers',
      request,
      metadata || {},
      methodDescriptor_Usernator_getAllUsers,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserDatas>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.getAllUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/getAllUsers',
      request,
      metadata || {},
      methodDescriptor_Usernator_getAllUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_getUserInfo = new grpc.web.MethodDescriptor(
  '/users.Usernator/getUserInfo',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.UserData,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.getUserInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/getUserInfo',
      request,
      metadata || {},
      methodDescriptor_Usernator_getUserInfo,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.getUserInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/getUserInfo',
      request,
      metadata || {},
      methodDescriptor_Usernator_getUserInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_updateUserInfo = new grpc.web.MethodDescriptor(
  '/users.Usernator/updateUserInfo',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.UserData,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.updateUserInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/updateUserInfo',
      request,
      metadata || {},
      methodDescriptor_Usernator_updateUserInfo,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.updateUserInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/updateUserInfo',
      request,
      metadata || {},
      methodDescriptor_Usernator_updateUserInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_getFollowSettings = new grpc.web.MethodDescriptor(
  '/users.Usernator/getFollowSettings',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.UserData,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.getFollowSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/getFollowSettings',
      request,
      metadata || {},
      methodDescriptor_Usernator_getFollowSettings,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.getFollowSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/getFollowSettings',
      request,
      metadata || {},
      methodDescriptor_Usernator_getFollowSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_updateFollowSettings = new grpc.web.MethodDescriptor(
  '/users.Usernator/updateFollowSettings',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.UserData,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.updateFollowSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/updateFollowSettings',
      request,
      metadata || {},
      methodDescriptor_Usernator_updateFollowSettings,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.updateFollowSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/updateFollowSettings',
      request,
      metadata || {},
      methodDescriptor_Usernator_updateFollowSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.FollowRequestsData>}
 */
const methodDescriptor_Usernator_listFollowRequests = new grpc.web.MethodDescriptor(
  '/users.Usernator/listFollowRequests',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.FollowRequestsData,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.FollowRequestsData.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.FollowRequestsData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.FollowRequestsData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.listFollowRequests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/listFollowRequests',
      request,
      metadata || {},
      methodDescriptor_Usernator_listFollowRequests,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.FollowRequestsData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.listFollowRequests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/listFollowRequests',
      request,
      metadata || {},
      methodDescriptor_Usernator_listFollowRequests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.FollowRequestAction,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_approveFollowRequest = new grpc.web.MethodDescriptor(
  '/users.Usernator/approveFollowRequest',
  grpc.web.MethodType.UNARY,
  proto.users.FollowRequestAction,
  proto.users.UserData,
  /**
   * @param {!proto.users.FollowRequestAction} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.FollowRequestAction} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.approveFollowRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/approveFollowRequest',
      request,
      metadata || {},
      methodDescriptor_Usernator_approveFollowRequest,
      callback);
};


/**
 * @param {!proto.users.FollowRequestAction} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.approveFollowRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/approveFollowRequest',
      request,
      metadata || {},
      methodDescriptor_Usernator_approveFollowRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.FollowRequestAction,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_rejectFollowRequest = new grpc.web.MethodDescriptor(
  '/users.Usernator/rejectFollowRequest',
  grpc.web.MethodType.UNARY,
  proto.users.FollowRequestAction,
  proto.users.UserData,
  /**
   * @param {!proto.users.FollowRequestAction} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.FollowRequestAction} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.rejectFollowRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/rejectFollowRequest',
      request,
      metadata || {},
      methodDescriptor_Usernator_rejectFollowRequest,
      callback);
};


/**
 * @param {!proto.users.FollowRequestAction} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.rejectFollowRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/rejectFollowRequest',
      request,
      metadata || {},
      methodDescriptor_Usernator_rejectFollowRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.UserDatas>}
 */
const methodDescriptor_Usernator_getFollowers = new grpc.web.MethodDescriptor(
  '/users.Usernator/getFollowers',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.UserDatas,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserDatas.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserDatas)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserDatas>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.getFollowers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/getFollowers',
      request,
      metadata || {},
      methodDescriptor_Usernator_getFollowers,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserDatas>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.getFollowers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/getFollowers',
      request,
      metadata || {},
      methodDescriptor_Usernator_getFollowers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.UserDatas>}
 */
const methodDescriptor_Usernator_listOutgoingFollowRequests = new grpc.web.MethodDescriptor(
  '/users.Usernator/listOutgoingFollowRequests',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.UserDatas,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserDatas.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserDatas)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserDatas>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.listOutgoingFollowRequests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/listOutgoingFollowRequests',
      request,
      metadata || {},
      methodDescriptor_Usernator_listOutgoingFollowRequests,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserDatas>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.listOutgoingFollowRequests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/listOutgoingFollowRequests',
      request,
      metadata || {},
      methodDescriptor_Usernator_listOutgoingFollowRequests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.AddFriendRequest,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_cancelFollowRequest = new grpc.web.MethodDescriptor(
  '/users.Usernator/cancelFollowRequest',
  grpc.web.MethodType.UNARY,
  proto.users.AddFriendRequest,
  proto.users.UserData,
  /**
   * @param {!proto.users.AddFriendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.AddFriendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.cancelFollowRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/cancelFollowRequest',
      request,
      metadata || {},
      methodDescriptor_Usernator_cancelFollowRequest,
      callback);
};


/**
 * @param {!proto.users.AddFriendRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.cancelFollowRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/cancelFollowRequest',
      request,
      metadata || {},
      methodDescriptor_Usernator_cancelFollowRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.AddFriendRequest,
 *   !proto.users.UserData>}
 */
const methodDescriptor_Usernator_removeFollower = new grpc.web.MethodDescriptor(
  '/users.Usernator/removeFollower',
  grpc.web.MethodType.UNARY,
  proto.users.AddFriendRequest,
  proto.users.UserData,
  /**
   * @param {!proto.users.AddFriendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.UserData.deserializeBinary
);


/**
 * @param {!proto.users.AddFriendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.UserData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.UserData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.removeFollower =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/removeFollower',
      request,
      metadata || {},
      methodDescriptor_Usernator_removeFollower,
      callback);
};


/**
 * @param {!proto.users.AddFriendRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.UserData>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.removeFollower =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/removeFollower',
      request,
      metadata || {},
      methodDescriptor_Usernator_removeFollower);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.DeleteAccountRequest,
 *   !proto.users.DeletionStatus>}
 */
const methodDescriptor_Usernator_requestAccountDeletion = new grpc.web.MethodDescriptor(
  '/users.Usernator/requestAccountDeletion',
  grpc.web.MethodType.UNARY,
  proto.users.DeleteAccountRequest,
  proto.users.DeletionStatus,
  /**
   * @param {!proto.users.DeleteAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.DeletionStatus.deserializeBinary
);


/**
 * @param {!proto.users.DeleteAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.DeletionStatus)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.DeletionStatus>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.requestAccountDeletion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/requestAccountDeletion',
      request,
      metadata || {},
      methodDescriptor_Usernator_requestAccountDeletion,
      callback);
};


/**
 * @param {!proto.users.DeleteAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.DeletionStatus>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.requestAccountDeletion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/requestAccountDeletion',
      request,
      metadata || {},
      methodDescriptor_Usernator_requestAccountDeletion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.DeletionStatus>}
 */
const methodDescriptor_Usernator_cancelAccountDeletion = new grpc.web.MethodDescriptor(
  '/users.Usernator/cancelAccountDeletion',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.DeletionStatus,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.DeletionStatus.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.DeletionStatus)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.DeletionStatus>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.cancelAccountDeletion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/cancelAccountDeletion',
      request,
      metadata || {},
      methodDescriptor_Usernator_cancelAccountDeletion,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.DeletionStatus>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.cancelAccountDeletion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/cancelAccountDeletion',
      request,
      metadata || {},
      methodDescriptor_Usernator_cancelAccountDeletion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.DeletionStatus>}
 */
const methodDescriptor_Usernator_getDeletionStatus = new grpc.web.MethodDescriptor(
  '/users.Usernator/getDeletionStatus',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.DeletionStatus,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.DeletionStatus.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.DeletionStatus)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.DeletionStatus>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.getDeletionStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/getDeletionStatus',
      request,
      metadata || {},
      methodDescriptor_Usernator_getDeletionStatus,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.DeletionStatus>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.getDeletionStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/getDeletionStatus',
      request,
      metadata || {},
      methodDescriptor_Usernator_getDeletionStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.users.UserData,
 *   !proto.users.DataExport>}
 */
const methodDescriptor_Usernator_exportMyData = new grpc.web.MethodDescriptor(
  '/users.Usernator/exportMyData',
  grpc.web.MethodType.UNARY,
  proto.users.UserData,
  proto.users.DataExport,
  /**
   * @param {!proto.users.UserData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.users.DataExport.deserializeBinary
);


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.users.DataExport)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.users.DataExport>|undefined}
 *     The XHR Node Readable Stream
 */
proto.users.UsernatorClient.prototype.exportMyData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/users.Usernator/exportMyData',
      request,
      metadata || {},
      methodDescriptor_Usernator_exportMyData,
      callback);
};


/**
 * @param {!proto.users.UserData} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.users.DataExport>}
 *     Promise that resolves to the response
 */
proto.users.UsernatorPromiseClient.prototype.exportMyData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/users.Usernator/exportMyData',
      request,
      metadata || {},
      methodDescriptor_Usernator_exportMyData);
};


module.exports = proto.users;

